import { batch, useDispatch } from "react-redux";
import { useCallback, useEffect } from "react";

import getProfessionCategoriesAction from "../../actions/ProfessionActions/getProfessionCategoriesAction";
import getProfessionsAction from "../../actions/ProfessionActions/getProfessionsAction";

export default function useProfessionsAndCategories() {
    const dispatch = useDispatch();
    const getProfessionsAndCategories = useCallback(() => {
        batch(() => {
            dispatch(getProfessionsAction());
            dispatch(getProfessionCategoriesAction());
        });
    }, [dispatch]);
    useEffect(() => {
        getProfessionsAndCategories();
    }, [getProfessionsAndCategories]);
}
